import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    padding: `0 ${theme.spacing.space16}px`,
    gap: theme.spacing.space12,
    overflowX: "scroll",
    position: "relative",
    "-ms-overflow-style": "none" /* IE and Edge */,
    scrollbarWidth: "none" /* Firefox */,
    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  button: {
    padding: `${theme.spacing.space8}px ${theme.spacing.space12}px`,
    fontFamily: "Poppins",
    fontSize: 14,
    lineHeight: "19.6px",
    fontWeight: theme.fontWeight.medium,
    borderRadius: theme.radius.small,
    background: theme.colors.Background4,
    color: theme.colors.TextDefault,
    border: `unset`,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    "&.underlined": {
      fontWeight: theme.fontWeight.regular,
      color: theme.colors.TextSilver,
      background: "transparent",
      borderRadius: 0,
    },
    "&.active": {
      "&.outlined": {
        boxShadow: `inset 0 0 0 1.5px ${theme.colors.Primary}`,
      },
      "&.contained": {
        background: theme.colors.Primary,
        color: theme.colors.TextDefault,
      },
      "&.underlined": {
        borderBottom: `2px solid ${theme.colors.Background9}`,
        fontWeight: theme.fontWeight.bold,
        color: theme.colors.TextDefault,
      },
    },
  },
}));
